import React from 'react';

interface VideoPlayerProps {
  src: string;
  className?: string;
  autoplay?: boolean;
  controls?: boolean;
  muted?: boolean;
  loop?: boolean;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  src,
  className = '',
  autoplay = true,
  controls = true,
  muted = true,
  loop = false
}) => {
  return (
    <div className={`relative w-full ${className}`}>
      <video
        src={src}
        autoPlay={autoplay}
        controls={controls}
        muted={muted}
        loop={loop}
        className="w-full h-auto rounded-lg"
        preload="metadata"
      >
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;